var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.8088 7.021C15.3573 7.021 14.7592 7.011 14.0146 7.011C12.1987 7.011 10.7055 5.508 10.7055 3.675V0.459C10.7055 0.206 10.5036 0 10.253 0H4.96363C2.49517 0 0.5 2.026 0.5 4.509V15.284C0.5 17.889 2.59022 20 5.16958 20H13.0463C15.5058 20 17.5 17.987 17.5 15.502V7.471C17.5 7.217 17.299 7.012 17.0475 7.013C16.6247 7.016 16.1177 7.021 15.8088 7.021Z",
    fill: "#714FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.0847 0.565417C12.7857 0.254417 12.2637 0.468417 12.2637 0.899417V3.53642C12.2637 4.64242 13.1747 5.55242 14.2807 5.55242C14.9777 5.56042 15.9457 5.56242 16.7677 5.56042C17.1887 5.55942 17.4027 5.05642 17.1107 4.75242C16.0557 3.65542 14.1667 1.68942 13.0847 0.565417Z",
    fill: "#714FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97447 9.38744H9.35947C9.77047 9.38744 10.1045 9.05444 10.1045 8.64344C10.1045 8.23244 9.77047 7.89844 9.35947 7.89844H5.97447C5.56347 7.89844 5.23047 8.23244 5.23047 8.64344C5.23047 9.05444 5.56347 9.38744 5.97447 9.38744ZM5.97457 14.3816H11.4186C11.8296 14.3816 12.1636 14.0486 12.1636 13.6376C12.1636 13.2266 11.8296 12.8926 11.4186 12.8926H5.97457C5.56357 12.8926 5.23057 13.2266 5.23057 13.6376C5.23057 14.0486 5.56357 14.3816 5.97457 14.3816Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageIcon);
export default __webpack_public_path__ + "static/media/page-icon.2fb4bf5e19ec8e1e1ff618a7e8f0abaf.svg";
export { ForwardRef as ReactComponent };